export default __webpack_public_path__ + "static/media/card-warning.da888537.png";